import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIcons3mComponent } from './simple-icons-3m.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIcons3mComponent ],
    exports:      [ SimpleIcons3mComponent ],
    bootstrap:    []
})
export class SimpleIcons3mModule {}
